import { render, staticRenderFns } from "./section-pulse.vue?vue&type=template&id=15c4a5b6&scoped=true"
import script from "./section-pulse.vue?vue&type=script&lang=js"
export * from "./section-pulse.vue?vue&type=script&lang=js"
import style0 from "./section-pulse.vue?vue&type=style&index=0&id=15c4a5b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4a5b6",
  null
  
)

export default component.exports